import { isMaterial, isObject3D, isRenderer, isScene } from "./helper";
import { IPropertyStateProvider, PropertyViewMode } from "../../properties/common/properties";



export class ThreeDefaultViewMode implements IPropertyStateProvider {

    isHidden(object: object, key: string): boolean {

        if (isRenderer(object)) {
            // ONLY show these properties in default mode
            switch (key) {
                case "domElement":
                case "autoClear":
                case "autoClearColor":
                case "autoClearDepth":
                case "autoClearStencil":
                case "sortObjects":
                case "localClippingEnabled":
                case "toneMapping":
                case "toneMappingExposure":
                case "outputEncoding":
                case "outputColorSpace":
                    return false;
            }
            return true;
        }

        if (isScene(object)) {
            // ONLY show these properties in default mode
            switch (key) {
                case "id":
                case "name":
                case "background":
                case "environment":
                case "fog":
                    return false;
            }
            return true;
        }

        if (isObject3D(object)) {

            // ONLY show these properties in default mode

            switch (key) {
                case "type":
                case "id":
                case "name":
                case "visible":
                case "castShadow":
                case "receiveShadow":
                case "renderOrder":
                case "position":
                case "rotation":
                case "scale":
                case "quaternion":
                case "mask":
                    return false;
            }
            return true;

        }
        if (isMaterial(object)) {
            if (key.startsWith("is")) {
                return true;
            }
            switch (key) {
                case "uuid":
                case "id":
                case "version":
                case "needsUpdate":
                case "userData":

                case "colorWrite":
                case "depthWrite":
                case "depthTest":
                case "depthFunc":

                case "vertexColors":
                case "precision":
                case "polygonOffset":
                case "polygonOffsetFactor":
                case "polygonOffsetUnits":

                // stencil
                case "stencilFunc":
                case "stencilRef":
                case "stencilFail":
                case "stencilZFail":
                case "stencilZPass":
                case "stencilWriteMask":
                case "stencilFuncMask":
                case "stencilWrite":

                case "blending":
                case "blendSrc":
                case "blendDst":
                case "blendEquation":
                case "blendSrcAlpha":
                case "blendDstAlpha":
                case "blendEquationAlpha":
                case "blendColor":
                case "blendAlpha":

                case "wireframeLinewidth":
                case "wireframeLinecap":
                case "wireframeLinejoin":

                case "clippingPlanes":
                case "clipIntersection":
                case "clipShadows":
                case "forceSinglePass":


                case "defines":

                // needle
                case "LODS:minmax":

                    return true;
            }
        }
        return false;
    }
}